module.exports = __webpack_public_path__ + "img/docs.14517984.svg";